<div class="card">
  <div class="data-header">
    <button
      *ngIf="canCreate()"
      mat-raised-button
      color="primary"
      (click)="openDialog()"
    >
      <mat-icon>add</mat-icon>
      Nouvelle FEB
    </button>

    <mat-form-field class="filter-field">
      <mat-label>Filtre</mat-label>

      <input
        matInput
        (keyup)="applyFilter($event)"
      />
    </mat-form-field>

    <button
      mat-raised-button
      class="indigo"
      (click)="exportData()"
      [style.background-color]="theme.getColor('Main Dark')"
    >
      <mat-icon>get_app</mat-icon>
      Export Excel
    </button>
  </div>

  <div class="table-card">
    <div class="table-scroll">
      <mat-table
        class="table-container"
        [dataSource]="fiches"
        matSort
        (matSortChange)="announceSortChange($event)"
      >
        <!-- Label -->
        <ng-container matColumnDef="febLabel">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Label
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            [matTooltip]="row.febLabel"
          >
            <span class="feb-label">{{ row.febLabel }}</span>
          </mat-cell>
        </ng-container>

        <!-- Demandeur -->
        <ng-container matColumnDef="febDemandeurNom">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Demandeur
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            [matTooltip]="row.febDemandeurNom"
          >
            {{ row.febDemandeurNom }}
          </mat-cell>
        </ng-container>

        <!-- Projet -->
        <ng-container matColumnDef="febProjectNom">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Projet
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            [matTooltip]="row.febProjectNom"
          >
            {{ row.febProjectNom }}
          </mat-cell>
        </ng-container>

        <!-- Localisation -->
        <ng-container matColumnDef="febLocalisationLabel">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Localisation
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            [matTooltip]="row.febLocalisationLabel"
          >
            {{ row.febLocalisationLabel }}
          </mat-cell>
        </ng-container>

        <!-- Date de création -->
        <ng-container matColumnDef="createdAt">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
          >
            Créée le
          </mat-header-cell>

          <mat-cell *matCellDef="let row">
            {{ row.createdAt | date: 'dd/MM/yyyy HH:mm' }}
          </mat-cell>
        </ng-container>

        <!-- Statut -->
        <ng-container matColumnDef="febStatut">
          <mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            class="statut-col"
          >
            Statut
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            class="statut-col"
          >
            <span
              class="badge-statut"
              [ngClass]="{
                'statut-creee':
                  row.febStatut === FebStatut.CREEE,
                'statut-en-attente':
                  row.febStatut === FebStatut.EN_ATTENTE,
                'statut-validee':
                  row.febStatut === FebStatut.VALIDEE,
                'statut-archivee':
                  row.febStatut === FebStatut.ARCHIVEE
              }"
            >
              {{ row.febStatut === FebStatut.VALIDEE ? 'ACCEPTÉE' : (row.febStatut ?? 'CRÉÉE') }}
            </span>
          </mat-cell>
        </ng-container>

        <!-- Actions -->
        <ng-container matColumnDef="actions">
          <mat-header-cell
            *matHeaderCellDef
            class="actions-td"
          >
            Actions
          </mat-header-cell>

          <mat-cell
            *matCellDef="let row"
            class="actions-td"
          >
            <div class="actions-buttons">
              <!-- Envoyer au fournisseur -->
              <button
                *ngIf="canEnvoyer(row)"
                mat-icon-button
                class="btn-send"
                (click)="envoyerAuCds(row)"
                matTooltip="Envoyer au fournisseur"
              >
                <mat-icon>send</mat-icon>
              </button>

              <!-- Modifier -->
              <button
                *ngIf="canEdit(row)"
                mat-icon-button
                class="btn-edit"
                (click)="openDialog(row)"
                matTooltip="Modifier"
              >
                <mat-icon>mode_edit</mat-icon>
              </button>

              <!-- Visualiser -->
              <button
                mat-icon-button
                class="btn-view"
                (click)="openViewer(row)"
                matTooltip="Visualiser"
              >
                <mat-icon>visibility</mat-icon>
              </button>

              <!-- Dupliquer -->
              <button
                *ngIf="canDuplicate(row)"
                mat-icon-button
                class="btn-duplicate"
                (click)="duplicateFiche(row)"
                matTooltip="Dupliquer la FEB"
              >
                <mat-icon>content_copy</mat-icon>
              </button>

              <button
                *ngIf="canDownloadFeb(row)"
                mat-icon-button
                class="btn-download"
                (click)="downloadFeb(row)"
                matTooltip="Telecharger la fiche FEB"
              >
                <mat-icon>download</mat-icon>
              </button>

              <!-- Supprimer -->
              <button
                mat-icon-button
                class="btn-delete"
                (click)="deleteFiche(row)"
                [disabled]="!canDelete(row)"
                matTooltip="Supprimer"
              >
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </mat-cell>
        </ng-container>

        <!-- En-tête fixe -->
        <mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></mat-header-row>

        <!-- Lignes -->
        <mat-row
          *matRowDef="let row; columns: displayedColumns"
        ></mat-row>
      </mat-table>
    </div>
  </div>
</div>
